import { createContext, ReactNode, useState } from 'react'

export interface InitContextProps {
  sidebar: {
    open: boolean
    toggle: () => void
  }
  settings: {
    open: boolean
    toggle: () => void
  }
}

export const LayoutContext = createContext({} as InitContextProps)

interface LayoutProviderProps {
  children: ReactNode
}

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false)
  const [isSettingsOpen, setSettingsOpen] = useState(false)

  const toggleSidebar = () => {
    setSettingsOpen(false)
    setSidebarOpen(!isSidebarOpen)
  }

  const toggleSettings = () => {
    setSidebarOpen(false)
    setSettingsOpen(!isSettingsOpen)
  }

  const value = {
    sidebar: {
      open: isSidebarOpen,
      toggle: toggleSidebar,
    },
    settings: {
      open: isSettingsOpen,
      toggle: toggleSettings,
    },
  }

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  )
}
